import { completeEasyPaisaOrder } from './easypaisa-order-completion';

export interface PaymentResult {
	paymentTransactionId: string;
	status: string;
	paymentStatus: string;
}

export const createPaymentResult = async (json: string) => {
	try {
		const result = JSON.parse(json) as PaymentResult;

		completeEasyPaisaOrder(result);
	} catch (err) {
		console.error('createPaymentResult error:', err);
	}
};
